import React from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as pedidoActions from "../../reducers/pedidosReducer/actions";
import {
  pedidoReducerDataSelector,
  filtroPedidosSelector,
  ultimoItemActualizadoSelector,
} from "../../selectors/pedidosSelector";
import Pedidos from "../../components/Pedidos";
import {
  usuarioSelector,
  instalacionSelector,
  sucursalSelector,
} from "../../selectors/sessionSelector";
import * as sessionActions from "../../reducers/sessionReducer/actions";

class PedidosContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filtros:
        this.props.filtroPedidos &&
        this.props.filtroPedidos.pageSize &&
        this.props.filtroPedidos.pageSize > 0
          ? this.props.filtroPedidos
          : this.default_filters,
      openModal: false,
      usuarioCargado: false,
      pedidoInfoUsuario: undefined,
      instalacionCargada: false,
      openModalInfoUsuario: false,
      pedidosCargado: false,
    };

    /*let payload = this.state.filtros;
        payload.idSucursal = 1
        this.props.sagaGetPedidos(payload);*/

    // busco los estados de pedido
    if (this.props.data.estadosPedido === undefined) this.props.sagaGetEstadosPedido();

    // busco las formas de entrega
    this.props.sagaGetFormasEntrega();
  }

  componentDidUpdate = () => {
    if (this.state.usuarioCargado === false && this.props.usuario !== undefined) {
      this.setState({ usuarioCargado: true }, () => {
        if (this.props.usuario.idRol === 2) {
          window.location.hash = "/Articulo";
        }
      });
    }

    //UPDATE SUCURSAL SELECCIONADA
    const idSucursalLocal = localStorage.getItem("sucursalSeleccionada") || undefined;
    if (
      !this.props.sucursal?.idSucursal &&
      this.props.usuario &&
      this.props.usuario.sucursales?.length !== 0
    ) {
      let sucursalAux = this.props.usuario.sucursales.find(
        (x) => x.idSucursal === parseInt(idSucursalLocal)
      );
      if (sucursalAux) {
        this.props.setSucursal(sucursalAux);
        /*if(usuario && (usuario.idRol === 1 || usuario.idRol === 4)){
                    window.location.hash = '/Pedidos'
                    return
                }
                if(usuario && usuario.idRol === 2){
                    window.location.hash = '/Articulo'
                    return
                }*/
      } else {
        if (this.props.usuario.sucursales.length === 1) {
          localStorage.setItem("sucursalSeleccionada", this.props.usuario.sucursales[0].idSucursal);
          this.props.setSucursal(this.props.usuario.sucursales[0]);
        } else {
          window.location.hash = "/SeleccionSucursal";
        }
      }
    }

    if (this.state.instalacionCargada === false && this.props.instalacion !== undefined) {
      this.setState({ instalacionCargada: true }, () => {
        this.getFechaUltimoItemActualizado(this.props.instalacion.id);
      });
    }

    if (this.state.pedidosCargado === false && this.props.sucursal !== undefined) {
      this.setState({ pedidosCargado: true }, () => {
        this.props.sagaGetPedidos({
          ...this.state.filtros,
          idSucursal: this.props.sucursal.idSucursal,
        });
      });
    }
  };

  componentWillUnmount = () => {
    if (
      this.props.history &&
      this.props.history.location &&
      !this.props.history.location.pathname.startsWith("/PedidosDetalle")
    ) {
      this.props.setFilterPedidos(undefined);
    }
  };

  getFechaUltimoItemActualizado = (idInstalacion) => {
    //busco info de ultima actualización de catalogo entrada
    this.props.sagaGetUltimaActualizacion({ idInstalacion: idInstalacion });
  };

  default_filters = {
    idEstadoPedido: this.props.match.params.idEstado || 2,
    numeroPedido: this.props.numeroPedido,
    page: 0,
    pageSize: 14,

    // EL METODO DEL BACK ESTA FUNCIONANDO CORRECTAMENTE *creo* EL DE BUSQUEDA AVANZADA, FALTA NOMAS LLAMAR
    //A LA SAGAS PARA LA BUSQUEDA AVANZADA. TAMBIEN NOMAS FALTA EL HANDLER DE NUMEROPEDIDO Y IDESTADOPEDIDO PARA LA AVANZADA

    fechaDesde: undefined,
    fechaHasta: undefined,
    importeDesde: "",
    importeHasta: "",
    codigoArticulo: "",
    nombreArticulo: "",
    razonSocial: "",

    idCatalogo: this.props.match.params.idCatalogo || 0,
    //id de filtro seleccionado en el panel de control
    filtroSeleccionado: undefined,

    idFormaEntrega: 0,
  };

  filtrarPedidos = (nuevaBusqueda) => {
    let filtros = { ...this.state.filtros };
    filtros.filtroSeleccionado = undefined;
    filtros.idSucursal = this.props.sucursal.idSucursal;

    if (nuevaBusqueda) filtros.page = 0;

    if (this.state.openModal === false) {
      if (nuevaBusqueda) {
        let f = this.default_filters;

        f.idEstadoPedido = this.state.filtros.idEstadoPedido;
        f.numeroPedido = this.state.filtros.numeroPedido;
        f.page = filtros.page;
        f.pageSize = this.state.filtros.pageSize;
        f.filtroSeleccionado = undefined;
        f.idFormaEntrega = this.state.filtros.idFormaEntrega;
        f.idSucursal = this.props.sucursal.idSucursal;

        this.setState({ filtros: f }, () => {
          this.props.sagaGetPedidos(f);
          this.props.setFilterPedidos(f);
        });
      } else {
        this.props.sagaGetPedidos({
          ...this.state.filtros,
          idSucursal: this.props.sucursal.idSucursal,
        });
      }
    } else {
      //if (this.state.openModal === false && filtros.numeroPedido === "" && filtros.idEstadoPedido === this.props.idEstadoPedido) this.clearFiltros();

      this.setState(
        {
          openModal: false,
          ...filtros,
          filtroSeleccionado: undefined,
        },
        () => {
          this.props.sagaGetPedidos(filtros);
        }
      );
    }
  };

  handleOnFiltroChange = (event) => {
    let newFiltros = { ...this.state.filtros };
    newFiltros[event.target.name] = event.target.value;

    this.setState({ filtros: newFiltros }, () => {
      this.props.setFilterPedidos(newFiltros);
    });
  };

  handleOnLimpiarFiltro = (filterName) => {
    let newFiltros = { ...this.state.filtros };
    newFiltros[filterName] = "";

    this.setState({ filtros: newFiltros }, () => {
      this.props.setFilterPedidos(newFiltros);
    });
  };

  clearFiltros = () => {
    let filtros = this.default_filters;

    filtros.idEstadoPedido = this.state.filtros.idEstadoPedido;
    filtros.numeroPedido = this.state.filtros.numeroPedido;
    filtros.page = this.state.filtros.page;
    filtros.pageSize = this.state.filtros.pageSize;
    filtros.filtroSeleccionado = undefined;
    filtros.idFormaEntrega = this.state.filtros.idFormaEntrega;

    this.setState({ filtros: this.default_filters }, () => {
      this.props.setFilterPedidos(this.default_filters);
    });
  };

  handleOnPagination = (page) => {
    this.setState(
      { filtros: { ...this.state.filtros, page: page === 0 ? page : page - 1 } },
      () => {
        this.props.setFilterPedidos(this.state.filtros);
        this.filtrarPedidos(false);
      }
    );
  };

  handleOnOpenModalAvanzada = () => {
    this.clearFiltros();
    this.setState({
      openModal: true,
    });
  };

  handleOnVolver = () => {
    this.setState({
      openModal: false,
    });
  };

  handleOnBuscarAvanzada = () => {};

  handleFechaDesde = (e) => {
    let filtros = Object.assign({}, this.state.filtros);
    filtros.fechaDesde = e.target.value;
    this.setState({ filtros: filtros }, () => {
      this.props.setFilterPedidos(filtros);
    });
  };

  handleFechaHasta = (e) => {
    let filtros = Object.assign({}, this.state.filtros);
    filtros.fechaHasta = e.target.value;
    this.setState({ filtros: filtros }, () => {
      this.props.setFilterPedidos(filtros);
    });
  };

  handleOnChangeFiltroImporte = ({ target }) => {
    const { name, value } = target;

    let filtros = Object.assign({}, this.state.filtros);
    filtros[name] = value;
    this.setState({ filtros: filtros }, () => {
      this.props.setFilterPedidos(filtros);
    });
  };

  handleNombreArticulo = (e) => {
    let filtros = Object.assign({}, this.state.filtros);
    filtros.nombreArticulo = e.target.value;
    this.setState({ filtros: filtros }, () => {
      this.props.setFilterPedidos(filtros);
    });
  };

  handleRazonSocial = (e) => {
    let filtros = Object.assign({}, this.state.filtros);
    filtros.razonSocial = e.target.value;
    this.setState({ filtros: filtros }, () => {
      this.props.setFilterPedidos(filtros);
    });
  };

  handleCodigoArticulo = (e) => {
    let filtros = Object.assign({}, this.state.filtros);
    filtros.codigoArticulo = e.target.value;
    this.setState({ filtros: filtros }, () => {
      this.props.setFilterPedidos(filtros);
    });
  };

  handleNroPedido = (e) => {
    let filtros = Object.assign({}, this.state.filtros);
    filtros.nroPedido = e.target.value;
    this.setState({ filtros: filtros }, () => {
      this.props.setFilterPedidos(filtros);
    });
  };

  handleIdEstadoPedido = (e) => {
    let filtros = Object.assign({}, this.state.filtros);
    filtros.idEstadoPedidoAvanzada = e.target.value;
    this.setState({ filtros: filtros }, () => {
      this.props.setFilterPedidos(filtros);
    });
  };

  handleOnClickInfoUsuario = (item) => {
    this.setState({ pedidoInfoUsuario: item });
  };

  handleOnClickBtnInfo = (valor) => {
    this.setState({ pedidoInfoUsuario: valor });
  };

  render() {
    return (
      <Pedidos
        pedidos={
          this.props.data.pedidos && {
            ...this.props.data.pedidos,
            result: this.props.data.pedidos.result.map((p) => ({
              ...p,
              link: () => {
                this.props.sagaGetPedidoId(p.id);
                this.props.history.push("/PedidosDetalle/" + p.id);
              },
              caratula: () => {
                this.props.sagaCaratulaPedido(p.id);
              },
              remito: () => {
                this.props.sagaRemitoPedido(p.id);
              },
              handleOnClickInfoUsuario: this.handleOnClickInfoUsuario,
            })),
          }
        }
        nombreCatalogo={
          decodeURIComponent(this.props.match.params.nombreCatalogo) === "undefined"
            ? undefined
            : decodeURIComponent(this.props.match.params.nombreCatalogo)
        }
        estadosPedido={this.props.data.estadosPedido}
        formasEntrega={this.props.data.formasEntrega}
        filtros={this.state.filtros}
        pedidoInfoUsuario={this.state.pedidoInfoUsuario}
        handleOnClickInfoUsuario={this.handleOnClickInfoUsuario}
        handleOnFiltroChange={this.handleOnFiltroChange}
        handleOnLimpiarFiltro={this.handleOnLimpiarFiltro}
        handleOnFiltrar={this.filtrarPedidos}
        handleOnPagination={this.handleOnPagination}
        handleOnOpenModalAvanzada={this.handleOnOpenModalAvanzada}
        handleOnVolver={this.handleOnVolver}
        handleOnBuscarAvanzada={this.handleOnBuscarAvanzada}
        openModal={this.state.openModal}
        ultimoItemActualizado={this.props.ultimoItemActualizado}
        handleFechaDesde={this.handleFechaDesde}
        handleFechaHasta={this.handleFechaHasta}
        handleNombreArticulo={this.handleNombreArticulo}
        handleCodigoArticulo={this.handleCodigoArticulo}
        handleIdEstadoPedido={this.handleOnFiltroChange}
        handleNroPedido={this.handleOnFiltroChange}
        handleOnChangeFiltroImporte={this.handleOnChangeFiltroImporte}
        handleRazonSocial={this.handleRazonSocial}
        handleOnClickBtnInfo={(valor) => this.handleOnClickBtnInfo(valor)}
      />
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...pedidoActions,
      ...sessionActions,
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {
    data: pedidoReducerDataSelector(state),
    usuario: usuarioSelector(state),
    sucursal: sucursalSelector(state),
    filtroPedidos: filtroPedidosSelector(state),
    ultimoItemActualizado: ultimoItemActualizadoSelector(state),
    instalacion: instalacionSelector(state),
  };
}

PedidosContainer.propTypes = {
  idEstadoPedido: PropTypes.number,
  numeroPedido: PropTypes.string,
};

PedidosContainer.defaultProps = {
  idEstadoPedido: 0,
  numeroPedido: "",
};

export default connect(mapStateToProps, mapDispatchToProps)(PedidosContainer);
